import { actions as actions$1, idleState, loadingState, failedState, useSelector, useIntl, statusLoading, useDispatch, useSaga, ReducersRegistry } from '@grandvisionhq/state';
import { createSelector } from 'reselect';
import { isDefined } from '@grandvisionhq/utils';
import * as React from 'react';
import React__default from 'react';
import { all, takeLatest, put, call, select, cancel, getContext } from 'redux-saga/effects';
import classnames from 'classnames';
import { Modal, Button, MediaQuery, IconButton, WizardProgress } from '@grandvisionhq/common';
import { Heading, Text } from '@grandvisionhq/elements';
import { motion } from 'framer-motion';
import { Icon } from '@grandvisionhq/icons';
import { Form } from '@grandvisionhq/forms';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.
Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.
THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}
function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}
function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || from);
}

var idPayload = actions$1.payload();
var startConfigurator = actions$1.action('configurator/start', actions$1.payload());
var isStartConfiguratorWithId = function (id) { return function (a) {
    return actions$1.isType(a, startConfigurator) && a.payload.id === id;
}; };
/**
 * Stepping actions
 */
var nextStep = actions$1.action('configurator/next-step', idPayload);
var isNextStepWithId = function (id) { return function (a) {
    return actions$1.isType(a, nextStep) && a.payload.id === id;
}; };
var nextStepSuccess = actions$1.action('configurator/next-step-success', actions$1.payload());
var isNextStepSuccessWithId = function (id) { return function (a) {
    return actions$1.isType(a, nextStepSuccess) && a.payload.id === id;
}; };
var nextStepFailed = actions$1.action('configurator/next-step-failed', actions$1.payload());
var isNextStepFailedWithId = function (id) { return function (a) {
    return actions$1.isType(a, nextStepFailed) && a.payload.id === id;
}; };
var previousStep = actions$1.action('configurator/previous-step', idPayload);
var isPreviousStepWithId = function (id) { return function (a) {
    return actions$1.isType(a, previousStep) && a.payload.id === id;
}; };
var previousStepFailed = actions$1.action('configurator/previous-step-failed', actions$1.payload());
var isPreviousStepFailedWithId = function (id) { return function (a) {
    return actions$1.isType(a, previousStepFailed) && a.payload.id === id;
}; };
var previousStepSuccess = actions$1.action('configurator/previous-step-success', actions$1.payload());
var isPreviousStepSuccessWithId = function (id) { return function (a) {
    return actions$1.isType(a, previousStepSuccess) && a.payload.id === id;
}; };
/**
 * Footer actions
 */
var toggleFooter = actions$1.action('configurator/footer/toggle', idPayload);
var isToggleFooterWithId = function (id) { return function (a) {
    return actions$1.isType(a, toggleFooter) && a.payload.id === id;
}; };
var openFooter = actions$1.action('configurator/footer/open', idPayload);
var isOpenFooterWithId = function (id) { return function (a) {
    return actions$1.isType(a, openFooter) && a.payload.id === id;
}; };
var closeFooter$1 = actions$1.action('configurator/footer/close', idPayload);
var isCloseFooterWithId = function (id) { return function (a) {
    return actions$1.isType(a, closeFooter$1) && a.payload.id === id;
}; };
var stepShown = actions$1.action('configurator/step-shown', actions$1.payload());
var isStepShownWithId = function (id) { return function (a) {
    return actions$1.isType(a, stepShown) && a.payload.id === id;
}; };
var finish = actions$1.action('configurator/finish', actions$1.payload());
var isFinishWithId = function (id) { return function (a) {
    return actions$1.isType(a, finish) && a.payload.id === id;
}; };
var finishFailed = actions$1.action('configurator/finish-failed', actions$1.payload());
var finishSuccess = actions$1.action('configurator/finish-success', actions$1.payload());

var actions = /*#__PURE__*/Object.freeze({
    __proto__: null,
    startConfigurator: startConfigurator,
    isStartConfiguratorWithId: isStartConfiguratorWithId,
    nextStep: nextStep,
    isNextStepWithId: isNextStepWithId,
    nextStepSuccess: nextStepSuccess,
    isNextStepSuccessWithId: isNextStepSuccessWithId,
    nextStepFailed: nextStepFailed,
    isNextStepFailedWithId: isNextStepFailedWithId,
    previousStep: previousStep,
    isPreviousStepWithId: isPreviousStepWithId,
    previousStepFailed: previousStepFailed,
    isPreviousStepFailedWithId: isPreviousStepFailedWithId,
    previousStepSuccess: previousStepSuccess,
    isPreviousStepSuccessWithId: isPreviousStepSuccessWithId,
    toggleFooter: toggleFooter,
    isToggleFooterWithId: isToggleFooterWithId,
    openFooter: openFooter,
    isOpenFooterWithId: isOpenFooterWithId,
    closeFooter: closeFooter$1,
    isCloseFooterWithId: isCloseFooterWithId,
    stepShown: stepShown,
    isStepShownWithId: isStepShownWithId,
    finish: finish,
    isFinishWithId: isFinishWithId,
    finishFailed: finishFailed,
    finishSuccess: finishSuccess
});

var createInitialConfiguratorState = function (stateOverrides) {
    var _a, _b;
    return (__assign({ currentStep: 0, stepSequence: [], stepsAttempted: new Set(), stepsVisited: [(_b = (_a = stateOverrides === null || stateOverrides === void 0 ? void 0 : stateOverrides.stepSequence) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : ''], calls: {
            finish: idleState(),
        }, isFooterOpen: false }, stateOverrides));
};
var setStateById = function (state, id, cb) {
    var _a;
    var configuratorState = state[id];
    return configuratorState
        ? __assign(__assign({}, state), (_a = {}, _a[id] = __assign(__assign({}, configuratorState), cb(configuratorState)), _a)) : state;
};
var initialState = {};
var reducer = actions$1.reducer(initialState, 
/**
 * Set the correct productSku and always reset the configurator to the initial state
 */
actions$1.on(startConfigurator, function (s, _a) {
    var _b;
    var _c = _a.payload, id = _c.id, stepSequence = _c.stepSequence;
    return (__assign(__assign({}, s), (_b = {}, _b[id] = __assign({}, createInitialConfiguratorState({ stepSequence: stepSequence })), _b)));
}), 
/**
 * When user tries to move on to the next step record so we mark the form as submitted
 *
 * This will reveal validation errors
 */
actions$1.on(nextStep, function (s, _a) {
    var id = _a.payload.id;
    return setStateById(s, id, function (c) {
        var _a;
        return (__assign(__assign({}, c), { stepsAttempted: new Set(__spreadArray(__spreadArray([], __read(((_a = c.stepsAttempted) !== null && _a !== void 0 ? _a : []))), [c.currentStep])) }));
    });
}), 
/**
 * When the steps change is allowed it's communicated by dispatching the nextStepSuccess action
 */
actions$1.on(nextStepSuccess, function (s, _a) {
    var _b = _a.payload, id = _b.id, newStep = _b.newStep;
    return setStateById(s, id, function (c) { return (__assign(__assign({}, c), { currentStep: newStep, stepsVisited: __spreadArray([], __read(new Set(__spreadArray(__spreadArray([], __read(c.stepsVisited)), [c.stepSequence[newStep]])))) })); });
}), 
/**
 * When the current step is moved back it's communicated by dispatching the previousStepSuccess action
 *
 * When user returns from step 3 to step 2, both 3 (currentStep) and 2 (newStep) are removed so we don't show error messages when returning
 */
actions$1.on(previousStepSuccess, function (s, _a) {
    var _b = _a.payload, id = _b.id, currentStepNumber = _b.currentStepNumber, newStep = _b.newStep;
    return setStateById(s, id, function (c) { return (__assign(__assign({}, c), { currentStep: newStep, stepsAttempted: new Set(__spreadArray([], __read(c.stepsAttempted)).filter(function (step) { return step !== currentStepNumber && step !== newStep; })) })); });
}), 
/**
 * Toggles footer
 */
actions$1.on(toggleFooter, function (s, _a) {
    var id = _a.payload.id;
    return setStateById(s, id, function (c) { return (__assign(__assign({}, c), { isFooterOpen: !c.isFooterOpen })); });
}), actions$1.on(closeFooter$1, function (s, _a) {
    var id = _a.payload.id;
    return setStateById(s, id, function (c) { return (__assign(__assign({}, c), { isFooterOpen: false })); });
}), actions$1.on(openFooter, function (s, _a) {
    var id = _a.payload.id;
    return setStateById(s, id, function (c) { return (__assign(__assign({}, c), { isFooterOpen: true })); });
}), 
/**
 * Tracks the status of the finish call
 */
actions$1.on(finish, function (s, _a) {
    var id = _a.payload.id;
    return setStateById(s, id, function (c) { return (__assign(__assign({}, c), { calls: __assign(__assign({}, c.calls), { finish: loadingState() }) })); });
}), actions$1.on(finishFailed, function (s, _a) {
    var _b = _a.payload, id = _b.id, reason = _b.reason;
    return setStateById(s, id, function (c) { return (__assign(__assign({}, c), { calls: __assign(__assign({}, c.calls), { finish: failedState(reason) }) })); });
}), actions$1.on(finishSuccess, function (s, _a) {
    var id = _a.payload.id;
    return setStateById(s, id, function (c) { return (__assign(__assign({}, c), { calls: __assign(__assign({}, c.calls), { finish: idleState() }) })); });
}));

var isDynamicStep = function (step) { return step.hasOwnProperty('stepStatus'); };

/**
 * Selectors for prop forwarding
 */
var stateProp$1 = function (s) { return s; };
var configuratorIdProp$1 = function (_, _a) {
    var id = _a.id;
    return id;
};
var stepNameProp$1 = function (_, _a) {
    var stepName = _a.stepName;
    return stepName;
};
var stepsMapProp = function (_, _a) {
    var stepsMap = _a.stepsMap;
    return stepsMap;
};
var stepSequenceProp = function (_, _a) {
    var stepSequence = _a.stepSequence;
    return stepSequence;
};
var getConfigurators = function (state) { return state.configurators; };
var getConfigurator$1 = createSelector(getConfigurators, configuratorIdProp$1, function (configurators, id) { return configurators[id]; });
/**
 * Step related selectors
 */
var getStepSequence = createSelector(getConfigurator$1, function (c) { return c === null || c === void 0 ? void 0 : c.stepSequence; });
var getCurrentStepNumber = createSelector(getConfigurator$1, function (c) { return c === null || c === void 0 ? void 0 : c.currentStep; });
var getStepsVisited = createSelector(getConfigurator$1, function (c) { return c === null || c === void 0 ? void 0 : c.stepsVisited; });
var getStepsList = createSelector(stepsMapProp, stepSequenceProp, getCurrentStepNumber, function (s) { return s; }, function (stepsMap, stepSequence, currentStepNumber, s) {
    return (stepSequence || []).reduce(function (acc, stepName, i) {
        var stepStatus = 'active';
        if (!stepsMap) {
            return [];
        }
        var step = stepsMap[stepName];
        if (!step) {
            return acc;
        }
        if (isDynamicStep(step)) {
            stepStatus = step.stepStatus(s);
            if (stepStatus === 'hidden') {
                return acc;
            }
        }
        return __spreadArray(__spreadArray([], __read(acc)), [
            {
                name: stepName,
                isCurrent: currentStepNumber === i,
                skip: stepStatus === 'skip',
            },
        ]);
    }, []);
});
var getActiveSteps = createSelector(getStepsList, function (steps) {
    return (steps || []).filter(function (s) { return !s.skip; });
});
var getStepNames = createSelector(getStepsList, function (steps) { return steps.map(function (s) { return s.name; }); });
var getCurrentStepIndex = createSelector(getStepsList, function (steps) {
    var index = steps.findIndex(function (s) { return s.isCurrent; });
    return index < 0 ? undefined : index;
});
var getCurrentStepName = createSelector(getStepsList, function (steps) { var _a; return (_a = steps.find(function (s) { return s.isCurrent; })) === null || _a === void 0 ? void 0 : _a.name; });
// We disable all steps from the active step onwards, because we don't support jumping forward by clicking in the header
var getDisableSteps = createSelector(getStepNames, getCurrentStepIndex, function (stepNames, currentStepIndex) {
    if (!isDefined(currentStepIndex)) {
        return [];
    }
    // We disable all steps from the active step onwards, because we don't support jumping forward by clicking in the header
    return Array.from(stepNames, function (_, i) { return i; }).slice(currentStepIndex + 1);
});
var getSkipSteps = createSelector(getStepsList, function (steps) {
    return steps.reduce(function (acc, step, i) { return (step.skip ? __spreadArray(__spreadArray([], __read(acc)), [i]) : acc); }, []);
});

var configuratorIdProp = configuratorIdProp$1, stateProp = stateProp$1, stepNameProp = stepNameProp$1;
var getConfigurator = createSelector(configuratorIdProp, stateProp, function (id, s) {
    return getConfigurator$1(s, { id: id });
});
/**
 * Exported selectors to be used in container components
 */
var hasAttemptedNextStep = createSelector(getConfigurator, function (c) {
    return c ? c.stepsAttempted.has(c.currentStep) : false;
});
var getCurrentStep = createSelector(getStepSequence, getCurrentStepNumber, configuratorIdProp, stateProp, function (stepSequence, currentStep) {
    if (!isDefined(stepSequence) || !isDefined(currentStep)) {
        return;
    }
    return {
        name: stepSequence[currentStep],
    };
});
/**
 * Checks the step name against the list of visited steps in the state.
 */
var hasVisitedStep = createSelector(getStepsVisited, configuratorIdProp, stepNameProp, function (stepsVisited, id, stepName) { return (stepsVisited || []).includes(stepName); });
var isFooterOpen = createSelector(getConfigurator, function (c) { var _a; return (_a = c === null || c === void 0 ? void 0 : c.isFooterOpen) !== null && _a !== void 0 ? _a : false; });
/**
 * Checks if we're on the last step, taking into consideration any steps that are disabled or to be skipped.
 */
var isLastStep = createSelector(getStepsList, function (steps) {
    var _a;
    if (!steps) {
        return false;
    }
    var lastStepIsCurrentStep = (_a = steps[steps.length - 1]) === null || _a === void 0 ? void 0 : _a.isCurrent;
    if (!isDefined(lastStepIsCurrentStep)) {
        return false;
    }
    if (lastStepIsCurrentStep) {
        return true;
    }
    // We're not on the last step, so we have to check if all steps following the current steps should be skipped.
    var currentStep = steps.findIndex(function (s) { return s.isCurrent; });
    var remainingSteps = steps.slice(currentStep + 1);
    return remainingSteps.every(function (s) { return s.skip; });
});
var getFinishCall = createSelector(getConfigurator, function (c) { return c === null || c === void 0 ? void 0 : c.calls.finish; });

var selectors = /*#__PURE__*/Object.freeze({
    __proto__: null,
    getConfigurator: getConfigurator,
    hasAttemptedNextStep: hasAttemptedNextStep,
    getCurrentStep: getCurrentStep,
    hasVisitedStep: hasVisitedStep,
    isFooterOpen: isFooterOpen,
    isLastStep: isLastStep,
    getFinishCall: getFinishCall
});

var ConfiguratorContext = React.createContext(null);
var useConfiguratorContext = function () {
    var context = React.useContext(ConfiguratorContext);
    if (context === null) {
        throw Error("Consumer of useConfiguratorContext needs to be wrapped in a ConfiguratorContext provider.");
    }
    return context;
};
var ConfiguratorContextProvider = function (_a) {
    var children = _a.children, 
    /**
     * This is everything in ConfiguratorContextModel
     */
    rest = __rest(_a, ["children"]);
    return React.createElement(ConfiguratorContext.Provider, { value: rest }, children);
};

var PrivateSteppingContext = React.createContext(null);
/**
 * This hook is not exported outside of this module. It is not meant to be used by consumers.
 */
var usePrivateSteppingContext = function () {
    var context = React.useContext(PrivateSteppingContext);
    if (context === null) {
        throw Error("Consumer of useSteppingContext needs to be wrapped in a PrivateSteppingContext provider.");
    }
    return context;
};
var PrivateSteppingContextProvider = function (_a) {
    var children = _a.children, configuratorId = _a.configuratorId, stepsMap = _a.stepsMap, stepSequence = _a.stepSequence, lastStepCTALabelKey = _a.lastStepCTALabelKey, footerTopBarContent = _a.footerTopBarContent, footerExpanderContent = _a.footerExpanderContent;
    var id = configuratorId;
    var selectorProps = React.useMemo(function () { return ({ id: id, stepsMap: stepsMap, stepSequence: stepSequence }); }, [
        id,
        stepsMap,
        stepSequence,
    ]);
    var context = {
        selectorProps: selectorProps,
        configuratorId: configuratorId,
        stepsMap: stepsMap,
        lastStepCTALabelKey: lastStepCTALabelKey,
        footerExpanderContent: footerExpanderContent,
        footerTopBarContent: footerTopBarContent,
    };
    return (React.createElement(PrivateSteppingContext.Provider, { value: context }, children));
};

/**
 * Utils
 */
function logUndefinedStep(configuratorId, currentStep) {
    console.warn("Could not determine the current step of configurator with ID \"" + configuratorId + "\". Received " + currentStep);
}
function logUndefinedStepProperty(configuratorId, propertyName, propertyValue) {
    console.warn("Could not determine property \"" + propertyName + "\" of the current step in configurator with ID \"" + configuratorId + "\". Received " + propertyValue);
}
function getConfiguratorContext(id) {
    var configuratorSagaContext, stepsMap, stepSequence;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getContext(id)];
            case 1:
                configuratorSagaContext = _a.sent();
                if (!!isDefined(configuratorSagaContext)) return [3 /*break*/, 3];
                console.warn("Could not find the saga context of configurator with ID \"" + id + "\". Received " + configuratorSagaContext);
                return [4 /*yield*/, cancel()];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                stepsMap = configuratorSagaContext.stepsMap;
                stepSequence = configuratorSagaContext.stepSequence;
                if (!!isDefined(stepsMap)) return [3 /*break*/, 5];
                logUndefinedStepProperty(id, 'stepsMap', stepsMap);
                return [4 /*yield*/, cancel()];
            case 4: return [2 /*return*/, _a.sent()];
            case 5:
                if (!!isDefined(stepSequence)) return [3 /*break*/, 7];
                logUndefinedStepProperty(id, 'stepSequence', stepSequence);
                return [4 /*yield*/, cancel()];
            case 6: return [2 /*return*/, _a.sent()];
            case 7: return [2 /*return*/, configuratorSagaContext];
        }
    });
}
function onNextStep(_a) {
    var configuratorSagaContext, stepsMap, stepSequence, activeSteps, currentStep, currentStepNumber, step, result, nextActiveStepName, nextActiveStepIndex;
    var id = _a.payload.id;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, call(getConfiguratorContext, id)];
            case 1:
                configuratorSagaContext = _b.sent();
                stepsMap = configuratorSagaContext.stepsMap, stepSequence = configuratorSagaContext.stepSequence;
                return [4 /*yield*/, select(getActiveSteps, { id: id, stepsMap: stepsMap, stepSequence: stepSequence })];
            case 2:
                activeSteps = _b.sent();
                return [4 /*yield*/, select(getCurrentStep, { id: id })];
            case 3:
                currentStep = _b.sent();
                if (!isDefined(currentStep)) {
                    logUndefinedStep(id, currentStep);
                    return [2 /*return*/];
                }
                return [4 /*yield*/, select(getCurrentStepNumber, { id: id })];
            case 4:
                currentStepNumber = _b.sent();
                if (!isDefined(currentStepNumber)) {
                    logUndefinedStepProperty(id, 'currentStepNumber', currentStepNumber);
                    return [2 /*return*/];
                }
                step = stepsMap === null || stepsMap === void 0 ? void 0 : stepsMap[currentStep.name];
                if (!isDefined(step)) {
                    console.error("Could not find step data for step with name \"" + currentStep.name + "\" in configurator with ID \"" + id + "\".");
                    return [2 /*return*/];
                }
                if (!step.onNext) return [3 /*break*/, 7];
                return [4 /*yield*/, call(step.onNext)];
            case 5:
                result = _b.sent();
                if (!result) return [3 /*break*/, 7];
                return [4 /*yield*/, put(nextStepFailed({ id: id, currentStepNumber: currentStepNumber, reason: result }))];
            case 6:
                _b.sent();
                return [2 /*return*/];
            case 7:
                nextActiveStepName = activeSteps.reduce(function (stepName, curr, index) { var _a; return (curr.isCurrent ? (_a = activeSteps[index + 1]) === null || _a === void 0 ? void 0 : _a.name : stepName); }, undefined);
                if (!!nextActiveStepName) return [3 /*break*/, 9];
                return [4 /*yield*/, put(finish({ id: id }))];
            case 8:
                _b.sent();
                return [2 /*return*/];
            case 9:
                if (!isDefined(stepSequence)) {
                    return [2 /*return*/];
                }
                nextActiveStepIndex = stepSequence.indexOf(nextActiveStepName);
                return [4 /*yield*/, put(nextStepSuccess({ id: id, currentStepNumber: currentStepNumber, newStep: nextActiveStepIndex }))];
            case 10:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
function triggerOnEnterForFirstStep(_a) {
    var configuratorSagaContext, stepsMap, steps, currentStepName, step, stepStatus, _b;
    var _c;
    var _d = _a.payload, id = _d.id, stepSequence = _d.stepSequence;
    return __generator(this, function (_e) {
        switch (_e.label) {
            case 0: return [4 /*yield*/, call(getConfiguratorContext, id)];
            case 1:
                configuratorSagaContext = _e.sent();
                stepsMap = configuratorSagaContext.stepsMap;
                return [4 /*yield*/, select(getStepsList, { id: id, stepsMap: stepsMap, stepSequence: stepSequence })];
            case 2:
                steps = _e.sent();
                currentStepName = (_c = steps[0]) === null || _c === void 0 ? void 0 : _c.name;
                if (!currentStepName) {
                    logUndefinedStepProperty(id, 'name', currentStepName);
                    return [2 /*return*/];
                }
                step = stepsMap[currentStepName];
                if (!isDefined(step)) {
                    logUndefinedStepProperty(id, 'name', step);
                    return [2 /*return*/];
                }
                if (!isDynamicStep(step)) return [3 /*break*/, 4];
                return [4 /*yield*/, select(step.stepStatus)];
            case 3:
                _b = _e.sent();
                return [3 /*break*/, 6];
            case 4: return [4 /*yield*/, select(function () { return 'active'; })];
            case 5:
                _b = _e.sent();
                _e.label = 6;
            case 6:
                stepStatus = _b;
                if (!(stepStatus !== 'active')) return [3 /*break*/, 8];
                return [4 /*yield*/, put(nextStep({ id: id }))];
            case 7:
                _e.sent();
                return [2 /*return*/];
            case 8:
                if (!(step && step.onEnter)) return [3 /*break*/, 10];
                return [4 /*yield*/, call(step.onEnter)];
            case 9:
                _e.sent();
                _e.label = 10;
            case 10: return [4 /*yield*/, put(stepShown({ id: id, step: currentStepName }))];
            case 11:
                _e.sent();
                return [2 /*return*/];
        }
    });
}
function onSuccessfulStepSwitch(_a) {
    var configuratorSagaContext, stepsMap, stepSequence, stepName, step;
    var _b = _a.payload, id = _b.id, newStep = _b.newStep;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, call(getConfiguratorContext, id)];
            case 1:
                configuratorSagaContext = _c.sent();
                stepsMap = configuratorSagaContext.stepsMap, stepSequence = configuratorSagaContext.stepSequence;
                if (!isDefined(stepSequence)) {
                    logUndefinedStepProperty(id, 'stepSequence', stepSequence);
                    return [2 /*return*/];
                }
                stepName = stepSequence[newStep];
                step = stepsMap === null || stepsMap === void 0 ? void 0 : stepsMap[stepName];
                if (!isDefined(step)) {
                    logUndefinedStep(id, step);
                    return [2 /*return*/];
                }
                if (!step.onEnter) return [3 /*break*/, 3];
                return [4 /*yield*/, call(step.onEnter)];
            case 2:
                _c.sent();
                _c.label = 3;
            case 3: return [4 /*yield*/, put(stepShown({ id: id, step: stepName }))];
            case 4:
                _c.sent();
                return [2 /*return*/];
        }
    });
}
function onPreviousStep(_a) {
    var configuratorSagaContext, stepsMap, stepSequence, activeSteps, currentStepNumber, previousActiveStepName, previousActiveStepIndex;
    var id = _a.payload.id;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, call(getConfiguratorContext, id)];
            case 1:
                configuratorSagaContext = _b.sent();
                stepsMap = configuratorSagaContext.stepsMap, stepSequence = configuratorSagaContext.stepSequence;
                return [4 /*yield*/, select(getActiveSteps, { id: id, stepsMap: stepsMap, stepSequence: stepSequence })];
            case 2:
                activeSteps = _b.sent();
                return [4 /*yield*/, select(getCurrentStepNumber, { id: id })];
            case 3:
                currentStepNumber = _b.sent();
                if (!isDefined(currentStepNumber)) {
                    logUndefinedStepProperty(id, 'currentStepNumber', currentStepNumber);
                    return [2 /*return*/];
                }
                previousActiveStepName = activeSteps.reduce(function (stepName, curr, index) { var _a; return (curr.isCurrent ? (_a = activeSteps[index - 1]) === null || _a === void 0 ? void 0 : _a.name : stepName); }, undefined);
                if (!!previousActiveStepName) return [3 /*break*/, 5];
                return [4 /*yield*/, put(previousStepFailed({
                        id: id,
                        currentStepNumber: currentStepNumber,
                        reason: new Error("Can't go back beyond the first step"),
                    }))];
            case 4:
                _b.sent();
                return [2 /*return*/];
            case 5:
                /**
                 * Get the index of first next active step from the *original* step sequence
                 */
                if (!isDefined(stepSequence)) {
                    logUndefinedStepProperty(id, 'stepSequence', stepSequence);
                    return [2 /*return*/];
                }
                previousActiveStepIndex = stepSequence.indexOf(previousActiveStepName);
                return [4 /*yield*/, put(previousStepSuccess({ id: id, currentStepNumber: currentStepNumber, newStep: previousActiveStepIndex }))];
            case 6:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
function closeFooter(_a) {
    var id = _a.payload.id;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, put(closeFooter$1({ id: id }))];
            case 1:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
function triggerOnFinishForLastStep(_a) {
    var configuratorSagaContext, onFinish, error_1;
    var id = _a.payload.id;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, call(getConfiguratorContext, id)];
            case 1:
                configuratorSagaContext = _b.sent();
                onFinish = configuratorSagaContext === null || configuratorSagaContext === void 0 ? void 0 : configuratorSagaContext.onFinish;
                if (!!onFinish) return [3 /*break*/, 3];
                return [4 /*yield*/, put(finishSuccess({ id: id }))];
            case 2:
                _b.sent();
                _b.label = 3;
            case 3:
                _b.trys.push([3, 5, , 7]);
                return [4 /*yield*/, call(onFinish)];
            case 4:
                _b.sent();
                return [3 /*break*/, 7];
            case 5:
                error_1 = _b.sent();
                return [4 /*yield*/, put(finishFailed({ id: id, reason: error_1 }))];
            case 6:
                _b.sent();
                return [3 /*break*/, 7];
            case 7: return [2 /*return*/];
        }
    });
}
function configuratorFactory(configuratorNamespace) {
    return {
        rootSaga: function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, all([
                            takeLatest(isStartConfiguratorWithId(configuratorNamespace), triggerOnEnterForFirstStep),
                            takeLatest(isNextStepWithId(configuratorNamespace), onNextStep),
                            takeLatest(isPreviousStepWithId(configuratorNamespace), onPreviousStep),
                            takeLatest([
                                isNextStepWithId(configuratorNamespace),
                                isPreviousStepWithId(configuratorNamespace),
                            ], closeFooter),
                            takeLatest([
                                isNextStepSuccessWithId(configuratorNamespace),
                                isPreviousStepSuccessWithId(configuratorNamespace),
                            ], onSuccessfulStepSwitch),
                            takeLatest(isFinishWithId(configuratorNamespace), triggerOnFinishForLastStep),
                        ])];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        },
    };
}

var CurrentStepContext = React.createContext(null);
/**
 * This hook is not exported outside of this module. It is not meant to be used by consumers.
 */
var useCurrentStepContext = function () {
    var context = React.useContext(CurrentStepContext);
    if (context === null) {
        throw Error("Consumer of useSteppingContext needs to be wrapped in a CurrentStepContext provider.");
    }
    return context;
};
var CurrentStepContextProvider = function (_a) {
    var children = _a.children;
    var _b = usePrivateSteppingContext(), stepsMap = _b.stepsMap, selectorProps = _b.selectorProps;
    var currentStepName = useSelector(function (s) {
        return getCurrentStepName(s, selectorProps);
    });
    if (!isDefined(currentStepName)) {
        throw new Error("currentStepName must be defined. However, \"" + currentStepName + "\" was received.");
    }
    var currentStep = stepsMap[currentStepName];
    if (!isDefined(currentStep)) {
        throw new Error("currentStep must be defined. However, \"" + currentStep + "\" was received.");
    }
    var context = {
        currentStep: currentStep,
        currentStepName: currentStepName,
    };
    return React.createElement(CurrentStepContext.Provider, { value: context }, children);
};

var ConfiguratorModal = function (_a) {
    var dataT = _a["data-t"], children = _a.children, className = _a.className, isOpen = _a.isOpen, onModalClose = _a.onModalClose;
    var getLabel = useIntl().getLabel;
    var goToPreviousStep = useConfiguratorContext().goToPreviousStep;
    var selectorProps = usePrivateSteppingContext().selectorProps;
    var steps = useSelector(function (s) {
        return getStepsList(s, selectorProps);
    });
    var currentStepIndex = useSelector(function (s) {
        return getCurrentStepIndex(s, selectorProps);
    });
    var isFirstStep = currentStepIndex === 0;
    var previousSteps = steps.slice(0, currentStepIndex);
    var allPreviousStepsSkipped = previousSteps.every(function (s) { return s.skip; });
    var handleBackClick = React__default.useCallback(function () {
        if (!isFirstStep) {
            goToPreviousStep();
        }
    }, [isFirstStep, goToPreviousStep]);
    var onBackClick = isFirstStep || allPreviousStepsSkipped ? undefined : handleBackClick;
    var backLabel = getLabel('common.actions.previous');
    var secondaryIconOptions = onBackClick && {
        'aria-label': backLabel,
        name: 'chevron-left',
        onClick: onBackClick,
        label: backLabel,
    };
    return (React__default.createElement(Modal, { "data-t": dataT, className: classnames('configurator-modal', className), secondaryIconOptions: secondaryIconOptions, onModalClose: onModalClose, isOpen: isOpen, isFullScreen: true, showIcon: true }, children));
};

var ConfiguratorStepTitleAndDescription = function (_a) {
    var title = _a.title, description = _a.description, titleClassName = _a.titleClassName, descriptionClassName = _a.descriptionClassName;
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Heading, { component: "h2", variant: "medium", align: "center", className: classnames('configurator-step-title', titleClassName) }, title),
        description && (React__default.createElement(Text, { className: classnames('configurator-step-description', descriptionClassName), variant: "body", align: "center" }, description))));
};

var ConfiguratorStepTitleAndDescriptionContainer = function (_a) {
    var titleClassName = _a.titleClassName, descriptionClassName = _a.descriptionClassName;
    var _b = useIntl(), getLabel = _b.getLabel, getFormattedLabel = _b.getFormattedLabel, hasLabel = _b.hasLabel;
    var currentStep = useCurrentStepContext().currentStep;
    var _c = currentStep.labelKeys, title = _c.title, description = _c.description;
    var labels = React__default.useMemo(function () { return ({
        title: getLabel(title),
        description: description && hasLabel(description)
            ? getFormattedLabel(description, {
                parseLink: true,
                openLinksInNewTab: true,
                hideLabelKey: true,
            })
            : undefined,
    }); }, [getLabel, title, description, getFormattedLabel, hasLabel]);
    return (React__default.createElement(ConfiguratorStepTitleAndDescription, __assign({}, labels, { titleClassName: titleClassName, descriptionClassName: descriptionClassName })));
};

var ConfiguratorStep = function (_a) {
    var children = _a.children, className = _a.className, rest = __rest(_a, ["children", "className"]);
    return (React.createElement("div", { className: classnames('configurator-step', className), "data-t": rest['data-t'] }, children));
};

var ConfiguratorStepContainer = function (props) {
    var currentStep = useCurrentStepContext().currentStep;
    var CurrentStepComponent = currentStep.view;
    return (React.createElement(ConfiguratorStep, __assign({}, props),
        React.createElement(CurrentStepComponent, null)));
};

var animations = {
    expanded: {
        height: 'auto',
        overflow: 'auto',
        transition: {
            ease: 'easeOut',
            duration: 0.2,
        },
    },
    collapsed: {
        height: '0px',
        overflow: 'hidden',
        transition: {
            ease: 'easeIn',
            duration: 0.2,
        },
    },
};
var Expander = function (_a) {
    var isExpanded = _a.isExpanded, children = _a.children;
    return (React.createElement(motion.div, { initial: animations.collapsed, animate: isExpanded ? animations.expanded : animations.collapsed, "aria-hidden": !isExpanded, className: "configurator-footer-expander" }, children));
};

var ExpanderContainer = function (_a) {
    var children = _a.children;
    var isFooterOpen = useConfiguratorContext().isFooterOpen;
    return React__default.createElement(Expander, { isExpanded: isFooterOpen }, children);
};

var CallToAction = function (_a) {
    var formId = _a.formId, label = _a.label, isLoading = _a.isLoading, isSmallScreen = _a.isSmallScreen;
    return (React.createElement(Button, { type: "submit", "data-t": "cta-button", caption: label, form: formId, isLoading: isLoading, size: isSmallScreen ? 'custom' : 'medium', className: "configurator-footer-cta" }));
};

var CallToActionContainer = function () {
    var getLabel = useIntl().getLabel;
    var isSmallScreen = MediaQuery.useIsBelow(MediaQuery.BreakpointName.TABLET_LANDSCAPE);
    var id = useConfiguratorContext().configuratorId;
    var _a = usePrivateSteppingContext(), lastStepCTALabelKey = _a.lastStepCTALabelKey, selectorProps = _a.selectorProps;
    var isOnLastStep = useSelector(function (s) {
        return isLastStep(s, selectorProps);
    });
    var finishCall = useSelector(function (s) { return getFinishCall(s, { id: id }); });
    var label = React.useMemo(function () {
        return isOnLastStep
            ? getLabel(lastStepCTALabelKey)
            : getLabel('products.glasses.configurator.footer.CTA');
    }, [isOnLastStep, getLabel]);
    return (React.createElement(CallToAction, { label: label, isLoading: statusLoading(finishCall || idleState()), isSmallScreen: isSmallScreen, formId: id }));
};

var ExpanderToggle = function (_a) {
    var label = _a.label, isExpanded = _a.isExpanded, onToggleClick = _a.onToggleClick;
    return (React.createElement(IconButton, { outline: true, onClick: onToggleClick, "aria-expanded": isExpanded, "aria-label": label, "data-t": "expander-toggle", className: "configurator-footer-expander-toggle" },
        React.createElement(Icon, { name: "chevron-up", height: 18, width: 18 })));
};

var ExpanderToggleContainer = function (props) {
    var dispatch = useDispatch();
    var getLabel = useIntl().getLabel;
    var _a = useConfiguratorContext(), isFooterOpen = _a.isFooterOpen, id = _a.configuratorId;
    var toggleFooter$1 = React.useCallback(function () {
        dispatch(toggleFooter({ id: id }));
    }, [dispatch, id]);
    var label = React.useMemo(function () { return getLabel('products.glasses.configurator.footer.toggle'); }, [
        getLabel,
    ]);
    return (React.createElement(ExpanderToggle, __assign({}, props, { label: label, isExpanded: isFooterOpen, onToggleClick: toggleFooter$1 })));
};

var TopBar = function (_a) {
    var children = _a.children;
    return (React.createElement("div", { className: "configurator-footer-topbar" },
        React.createElement("div", { className: "configurator-footer-topbar__content" }, children),
        React.createElement("div", { className: "configurator-footer-topbar__controls" },
            React.createElement(ExpanderToggleContainer, null),
            React.createElement(CallToActionContainer, null))));
};

var ConfiguratorFooter = function () {
    var _a = usePrivateSteppingContext(), footerTopBarContent = _a.footerTopBarContent, footerExpanderContent = _a.footerExpanderContent;
    return (React.createElement("footer", { "data-t": "configurator-footer", className: "configurator-footer" },
        React.createElement(TopBar, null, footerTopBarContent),
        React.createElement(ExpanderContainer, null, footerExpanderContent)));
};

var ConfiguratorHeader = function (_a) {
    var className = _a.className, currentStepIndex = _a.currentStepIndex, disableSteps = _a.disableSteps, skipSteps = _a.skipSteps, stepNameLabels = _a.stepNameLabels, rest = __rest(_a, ["className", "currentStepIndex", "disableSteps", "skipSteps", "stepNameLabels"]);
    var isPhone = MediaQuery.useIsPhone();
    return (React.createElement("div", { "data-t": rest['data-t'], className: classnames('configurator-header', className) },
        React.createElement(WizardProgress, { steps: stepNameLabels, active: currentStepIndex, disableSteps: disableSteps, skipSteps: skipSteps, labelStyle: isPhone ? 'hidden' : 'inline' })));
};

var ConfiguratorHeaderContainer = function () {
    var getLabel = useIntl().getLabel;
    var _a = usePrivateSteppingContext(), stepsMap = _a.stepsMap, selectorProps = _a.selectorProps;
    var currentStepIndex = useSelector(function (s) {
        return getCurrentStepIndex(s, selectorProps);
    });
    var disableSteps = useSelector(function (s) {
        return getDisableSteps(s, selectorProps);
    });
    var skipSteps = useSelector(function (s) {
        return getSkipSteps(s, selectorProps);
    });
    if (!isDefined(currentStepIndex)) {
        throw new Error("Need current step index to render configurator header. Received: \"" + currentStepIndex + "\".");
    }
    var steps = useSelector(function (s) {
        return getStepsList(s, selectorProps);
    });
    var enabledStepLabels = React__default.useMemo(function () {
        return steps.reduce(function (m, _a) {
            var name = _a.name;
            var stepData = stepsMap[name];
            return stepData ? __spreadArray(__spreadArray([], __read(m)), [getLabel(stepData.labelKeys.stepIndicatorTitle)]) : m;
        }, []);
    }, [getLabel, steps, stepsMap]);
    return (React__default.createElement(ConfiguratorHeader, { stepNameLabels: enabledStepLabels, currentStepIndex: currentStepIndex, disableSteps: disableSteps, skipSteps: skipSteps }));
};

var ConfiguratorMain = function (_a) {
    var className = _a.className, currentStepName = _a.currentStepName, children = _a.children, rest = __rest(_a, ["className", "currentStepName", "children"]);
    var mainRef = React.createRef();
    var isPhone = MediaQuery.useIsPhone();
    React.useLayoutEffect(function () {
        var _a;
        if (!isPhone) {
            return;
        }
        (_a = mainRef === null || mainRef === void 0 ? void 0 : mainRef.current) === null || _a === void 0 ? void 0 : _a.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    }, [currentStepName]);
    return (React.createElement("div", { ref: mainRef, "data-t": rest['data-t'], className: className }, children));
};

var ConfiguratorMainContainer = function (props) {
    var currentStepName = useCurrentStepContext().currentStepName;
    return React__default.createElement(ConfiguratorMain, __assign({ currentStepName: currentStepName }, props));
};

var Configurator = function (_a) {
    var dataT = _a["data-t"], className = _a.className, isOpen = _a.isOpen, onModalClose = _a.onModalClose;
    return (React__default.createElement(ConfiguratorModal, { isOpen: isOpen, onModalClose: onModalClose },
        React__default.createElement("div", { "data-t": dataT, className: classnames('configurator', className) },
            React__default.createElement(CurrentStepContextProvider, null,
                React__default.createElement(ConfiguratorHeaderContainer, null),
                React__default.createElement(ConfiguratorMainContainer, { className: "configurator__main" },
                    React__default.createElement(ConfiguratorStepContainer, null)),
                React__default.createElement(ConfiguratorFooter, null)))));
};

var useStepHandlers = function (id) {
    var dispatch = useDispatch();
    var goToNextStep = React.useCallback(function (e) {
        e === null || e === void 0 ? void 0 : e.preventDefault();
        dispatch(nextStep({ id: id }));
    }, [dispatch, id]);
    var goToPreviousStep = React.useCallback(function (e) {
        e === null || e === void 0 ? void 0 : e.preventDefault();
        dispatch(previousStep({ id: id }));
    }, [dispatch, id]);
    return {
        goToPreviousStep: goToPreviousStep,
        goToNextStep: goToNextStep,
    };
};
var ConfiguratorContainer = function (_a) {
    var _b;
    var id = _a.id, stepsMap = _a.stepsMap, stepSequence = _a.stepSequence, onFinish = _a.onFinish, lastStepCTALabelKey = _a.lastStepCTALabelKey, footerExpanderContent = _a.footerExpanderContent, footerTopBarContent = _a.footerTopBarContent, rest = __rest(_a, ["id", "stepsMap", "stepSequence", "onFinish", "lastStepCTALabelKey", "footerExpanderContent", "footerTopBarContent"]);
    var dispatch = useDispatch();
    // For the header
    var steps = useSelector(function (s) {
        return getStepsList(s, { id: id, stepsMap: stepsMap, stepSequence: stepSequence });
    });
    var currentStepName = (_b = steps.find(function (s) { return s.isCurrent; })) === null || _b === void 0 ? void 0 : _b.name;
    var isFooterOpen$1 = useSelector(function (s) { return isFooterOpen(s, { id: id }); });
    var hasAttemptedNextStep$1 = useSelector(function (s) {
        return hasAttemptedNextStep(s, { id: id });
    });
    var rootSaga = React.useMemo(function () { return configuratorFactory(id); }, [id]).rootSaga;
    var task = useSaga(rootSaga, {
        onStart: function (t) {
            var _a;
            t.setContext((_a = {}, _a[id] = { stepsMap: stepsMap, stepSequence: stepSequence, onFinish: onFinish }, _a));
            dispatch(startConfigurator({ id: id, stepSequence: stepSequence, stepsMap: stepsMap }));
        },
    }, [dispatch]);
    React.useEffect(function () {
        var _a;
        task === null || task === void 0 ? void 0 : task.setContext((_a = {}, _a[id] = { stepsMap: stepsMap, stepSequence: stepSequence, onFinish: onFinish }, _a));
    }, [task, stepsMap, stepSequence, onFinish]);
    var _c = useStepHandlers(id), goToNextStep = _c.goToNextStep, goToPreviousStep = _c.goToPreviousStep;
    if (!isDefined(currentStepName)) {
        return null;
    }
    var contextValues = {
        configuratorId: id,
        hasAttemptedNextStep: hasAttemptedNextStep$1,
        isFooterOpen: isFooterOpen$1,
        goToNextStep: goToNextStep,
        goToPreviousStep: goToPreviousStep,
        onFinish: onFinish,
    };
    return (React.createElement(PrivateSteppingContextProvider, { configuratorId: id, stepsMap: stepsMap, stepSequence: stepSequence, lastStepCTALabelKey: lastStepCTALabelKey, footerTopBarContent: footerTopBarContent, footerExpanderContent: footerExpanderContent },
        React.createElement(ConfiguratorContextProvider, __assign({}, contextValues),
            React.createElement(Configurator, __assign({}, rest)))));
};

var StepForm = function (_a) {
    var configuratorId = _a.configuratorId, onSubmit = _a.onSubmit, children = _a.children, className = _a.className, rest = __rest(_a, ["configuratorId", "onSubmit", "children", "className"]);
    return (React__default.createElement("form", { noValidate: true, onSubmit: onSubmit, id: configuratorId, "aria-label": rest['aria-label'], "data-t": rest['data-t'], className: classnames('step-form', className) }, children));
};
var ConnectedStepForm = function (_a) {
    var children = _a.children, initialFormState = _a.initialFormState, onChange = _a.onChange, configuratorId = _a.configuratorId, onSubmit = _a.onSubmit, className = _a.className, rest = __rest(_a, ["children", "initialFormState", "onChange", "configuratorId", "onSubmit", "className"]);
    var handleSubmit = React__default.useCallback(function () { return onSubmit(); }, [onSubmit]);
    return (React__default.createElement(Form, { name: configuratorId, "aria-label": rest['aria-label'], "data-t": rest['data-t'], className: classnames('step-form', className), initialFormState: initialFormState, onChange: onChange, onSubmit: handleSubmit }, children));
};

var StepFormContainer = function (props) {
    var getLabel = useIntl().getLabel;
    var configuratorId = useConfiguratorContext().configuratorId;
    var currentStep = useCurrentStepContext().currentStep;
    var labelKeys = currentStep.labelKeys;
    var labels = React__default.useMemo(function () { return ({
        ariaLabel: getLabel(labelKeys.title),
    }); }, [getLabel, labelKeys.title]);
    return React__default.createElement(StepForm, __assign({}, props, { configuratorId: configuratorId, "aria-label": labels.ariaLabel }));
};
var ConnectedStepFormContainer = function (props) {
    var getLabel = useIntl().getLabel;
    var configuratorId = useConfiguratorContext().configuratorId;
    var currentStep = useCurrentStepContext().currentStep;
    var labelKeys = currentStep.labelKeys;
    var labels = React__default.useMemo(function () { return ({
        ariaLabel: getLabel(labelKeys.title),
    }); }, [getLabel, labelKeys.title]);
    return (React__default.createElement(ConnectedStepForm, __assign({}, props, { configuratorId: configuratorId, "aria-label": labels.ariaLabel })));
};

/**
 * Configurator Module
 *
 * @grandvisionhq/configurator
 */
ReducersRegistry.register('configurators', reducer);

export { actions as Actions, CallToAction, ConfiguratorContainer as Configurator, ConfiguratorHeader, ConfiguratorStep, ConfiguratorStepTitleAndDescriptionContainer as ConfiguratorStepTitleAndDescription, ConnectedStepFormContainer as ConnectedStepForm, Expander, ExpanderToggle, selectors as Selectors, StepFormContainer as StepForm, isDynamicStep, useConfiguratorContext };
//# sourceMappingURL=index.js.map
